import actionType from "./customActionType";
import store from '../../store/store'
export const updateHireabilityStatus = (data) => {
    return {
        type: actionType.UPDATE_HIREABLITY_STATUS,
        payload: data
    }
}

export const setTotalModuleScore = (data) => {
    return {
        type: actionType.SET_TOTAL_MODULE_SCORES,
        payload: [].concat(data)
    }
}

export const updateTotalModuleScore = (data) => {
    let totalModuleScores = [].concat(store.getState().custom.totalModuleScores)
    totalModuleScores.forEach((currentItem, index) => {
        data.forEach((editItem) => {
            if (currentItem.moduleId == editItem.moduleId) {
                if (editItem.elementID && editItem.elementID === 'OS_TotalScore') {
                    totalModuleScores[index] = { ...currentItem, ...editItem }
                    // editItem.manualScoreObj only ever carries score/maxScore (the save response
                    // has no display label), and the spread above replaces manualScoreObj wholesale
                    // — preserve the existing header (e.g. "Evaluators' score") instead of losing it
                    // until the next full refetch brings it back.
                    if (editItem.manualScoreObj) {
                        totalModuleScores[index].manualScoreObj = {
                            ...currentItem?.manualScoreObj,
                            ...editItem.manualScoreObj,
                        }
                    }
                } else {
                    totalModuleScores[index] = {
                        ...totalModuleScores[index],
                        ...editItem,
                        moduleScore: editItem?.moduleScore || currentItem?.moduleScore,
                        manualScoreObj: {
                            ...totalModuleScores[index]?.manualScoreObj,
                            score: editItem?.manualScoreObj?.score,
                            maxScore: editItem?.manualScoreObj?.maxScore,
                        },
                    }
                }
            }
        })
    })

    return {
        type: actionType.UPDATE_TOTAL_MODULE_SCORES,
        payload: totalModuleScores
    }
}

export const updateVADCScaleNarratives = (data) => {
    return {
        type: actionType.UPDATE_MANUAL_VADC_SCALE_NARRATIVES,
        payload: data
    }
}

export const showToast = (data) => {
    return {
        type: actionType.TOASTENABLE,
        payload: data
    }
}

export const setChapterParams = (data) => {
    return {
        type : actionType.SET_CHAPTER_PARAMS,
        payload: data
    }
}

export const updateIndexOfAccordion = (data) => {
    let competencyData = {
        selectedCompetency : data.idx,
        selectedInterviewer : data.selectedParticipantId
    }
    return {
        type: actionType.SELECT_COMPETENCY,
        payload: competencyData
    }
}

